var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentsYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6867 30.5703C15.7319 30.5703 11.5 31.3357 11.5 34.3949C11.5 37.4564 15.705 38.2481 20.6867 38.2481C25.6414 38.2481 29.8733 37.4828 29.8733 34.4236C29.8733 31.3621 25.6683 30.5703 20.6867 30.5703Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.6862 27.656C24.0607 27.656 26.765 25.0077 26.765 21.703C26.765 18.3983 24.0607 15.75 20.6862 15.75C17.3129 15.75 14.6074 18.3983 14.6074 21.703C14.6074 25.0077 17.3129 27.656 20.6862 27.656Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.2175 21.8127C29.2175 23.4956 28.7013 25.0659 27.7962 26.3703C27.702 26.5045 27.7852 26.6854 27.9491 26.7141C28.1766 26.7512 28.4102 26.774 28.6487 26.7788C31.0215 26.8399 33.1509 25.3438 33.7392 23.0908C34.6113 19.7478 32.0526 16.7461 28.793 16.7461C28.4396 16.7461 28.1008 16.782 27.7705 16.8479C27.7253 16.8575 27.6764 16.879 27.6519 16.9174C27.6201 16.9665 27.6433 17.03 27.6751 17.0719C28.6548 18.417 29.2175 20.0544 29.2175 21.8127Z",
    fill: "#E5B910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2231 30.9627C35.7889 30.0559 34.7407 29.4343 33.1458 29.1288C32.3936 28.9492 30.3559 28.694 28.4613 28.73C28.4332 28.7336 28.4173 28.7527 28.4148 28.7647C28.4112 28.7839 28.4197 28.8126 28.4564 28.833C29.3322 29.257 32.7165 31.1016 32.2908 34.992C32.2725 35.1621 32.4107 35.3058 32.5831 35.2819C33.4161 35.1657 35.5589 34.7141 36.2231 33.3103C36.5912 32.5677 36.5912 31.7053 36.2231 30.9627Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsYellow);
export default __webpack_public_path__ + "static/media/agents-yellow.e88ca733cfee53a8c9e3c24a0f90de3b.svg";
export { ForwardRef as ReactComponent };